import { create } from 'zustand';

// Cross-feature "open a fresh China request draft" intent (#1753). CRM
// lead/deal "Create request" SETS this, then navigates to /china-rates,
// where RequestsListPage CONSUMES it and opens the draft on the requests
// feature's own store. This keeps the draft scratchpad + editor entirely
// inside features/requests (this store never imports it) while giving CRM a
// neutral, typed trigger — no feature→feature import, no command bus.
export interface FreshRequestDraftIntent {
  leadId?: string;
  dealId?: string;
}

interface RequestOpenState {
  pendingFreshDraft: FreshRequestDraftIntent | null;
  requestFreshDraft: (link: FreshRequestDraftIntent) => void;
  // Read-and-clear: returns the pending intent (or null) and clears it so the
  // consuming effect runs exactly once per navigation.
  consumePendingFreshDraft: () => FreshRequestDraftIntent | null;
}

export const useRequestOpenStore = create<RequestOpenState>((set, get) => ({
  pendingFreshDraft: null,
  requestFreshDraft: (link) => set({ pendingFreshDraft: link }),
  consumePendingFreshDraft: () => {
    const pending = get().pendingFreshDraft;
    if (pending) set({ pendingFreshDraft: null });
    return pending;
  },
}));
